import React from 'react';
import classNames from 'classnames';
import { EDITED_COMMENT_INDICATOR } from '../../../common/constants/data-hooks';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import styles from './edited-comment-indicator.module.scss';
export const EditedCommentIndicator = ({ onClick, className, onHover, disabled, }) => {
    const t = useTranslate();
    return (React.createElement("div", { "data-hook": EDITED_COMMENT_INDICATOR, className: classNames(styles.root, disabled && styles.isDisabled, className), onClick: () => !disabled && onClick(), onMouseEnter: () => !disabled && onHover?.() }, t('comment.edited-indicator')));
};
//# sourceMappingURL=edited-comment-indicator.js.map